"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MenuItemWraper = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var MenuItemWraper = exports.MenuItemWraper = _styledComponents["default"].div(function (_ref) {
  var isActive = _ref.isActive,
    enableFeature = _ref.enableFeature;
  return "\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n  padding: 16px 0;\n  width: 80px;\n  height: 72px;\n  font-size: 16px;\n  color: #fff;\n  align-items: center;\n  justify-content: space-between;\n  background: ".concat(isActive ? '' : '#282a39', ";\n  box-shadow: ").concat(isActive ? 'inset 4px 4px 16px #171923, inset -4px -4px 16px #171923, inset 0px 1px 0px #303245, inset 0px -1px 0px #2C2E3F' : 'inset 0px -1px 0px #333649', ";\n\n  &:hover {\n    background: ").concat(enableFeature ? '#282a39' : '#1e2130', ";\n    cursor: ").concat(enableFeature ? 'not-allowed' : 'pointer', ";\n  }\n");
});